import React from 'react';
import { cn } from '../../../utils/cn';

const ASSET_TYPE_STYLES = {
  STOCK: 'bg-emerald-50 text-emerald-700',
  BOND: 'bg-blue-50 text-blue-700',
  BALANCED: 'bg-violet-50 text-violet-700',
};

function formatNav(value) {
  if (value == null) return '--';
  return value.toLocaleString('vi-VN');
}

function formatPercent(value) {
  if (value == null) return '--';
  const sign = value > 0 ? '+' : '';
  return `${sign}${value.toFixed(2)}%`;
}

export default function ProductCard({ product, onClick }) {
  const { name, shortName, code, nav, navToPrevious, fundAssetType, issuerInfo } = product;
  const isPositive = navToPrevious > 0;
  const isNegative = navToPrevious < 0;

  return (
    <button
      type="button"
      onClick={() => onClick(product)}
      className="w-full rounded-xl border border-gray-200 bg-white p-4 text-left shadow-sm transition-all hover:border-blue-200 hover:shadow-md"
    >
      <div className="flex items-start gap-3">
        {issuerInfo?.avatarUrl ? (
          <img
            src={issuerInfo.avatarUrl}
            alt={issuerInfo.shortName}
            className="h-10 w-10 flex-shrink-0 rounded-lg object-contain"
          />
        ) : (
          <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-gray-100 text-xs font-bold text-gray-500">
            {(shortName || code || '?').slice(0, 3)}
          </div>
        )}
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-semibold text-gray-900">{shortName || name}</p>
          <p className="truncate text-xs text-gray-500">{code}</p>
        </div>
        {fundAssetType && (
          <span className={cn(
            'flex-shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
            ASSET_TYPE_STYLES[fundAssetType.code] || 'bg-gray-100 text-gray-600'
          )}>
            {fundAssetType.name}
          </span>
        )}
      </div>

      <div className="mt-3 flex items-end justify-between border-t border-gray-50 pt-3">
        <div>
          <p className="text-xs text-gray-500">NAV</p>
          <p className="text-lg font-bold text-gray-900">{formatNav(nav)}</p>
        </div>
        <div className="text-right">
          <p className="text-xs text-gray-500">So phien truoc</p>
          <p className={cn(
            'text-sm font-semibold',
            isPositive && 'text-emerald-600',
            isNegative && 'text-red-600',
            !isPositive && !isNegative && 'text-gray-500'
          )}>
            {formatPercent(navToPrevious)}
          </p>
        </div>
      </div>
    </button>
  );
}
